import { ITreatmentAssignmentApiModel } from '@app/shared/models/treatment-assignment-api.model';

export interface IVisitSlot {
  startDate: string;
  durationInMinutes: string;
  signature: string;
  treatmentAssignments: ITreatmentAssignmentApiModel[];
}
